import styled from 'styled-components'
import { BLACK, GRAYSCALE_400, GRAYSCALE_500, GRAYSCALE_600, NEUTRAL_100, LIGHT_GRAY_2, GRADIENT_SELECTED, GRADIENT_SELECTED_OVERLAY } from '../../styles/colors'
import { GIVONIC, INTER } from '../../styles/fonts'

interface OuterContainerProps {
  $selected?: boolean
}

export const OuterContainer = styled.div<OuterContainerProps>`
  position: relative;
  padding: 2px;
  border-radius: 16px;
  background: ${props => props.$selected ? GRADIENT_SELECTED : NEUTRAL_100};
  width: 100%;
  cursor: pointer;
`

interface InnerContainerProps {
  $selected?: boolean
}

export const InnerContainer = styled.div<InnerContainerProps>`
  display: flex;
  flex-direction: column;
  background: ${props => props.$selected ? GRADIENT_SELECTED_OVERLAY : LIGHT_GRAY_2};
  border-radius: 14px;
  padding: 16px;
  gap: 16px;
  position: relative;
  overflow: hidden;
`

export const RadioWrapper = styled.div`
  position: absolute;
  top: 6px;
  right: 6px;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const Title = styled.span`
  font-family: ${GIVONIC.semiBold};
  font-size: 14px;
  font-weight: 600;
  color: ${GRAYSCALE_600};
`

export const Description = styled.span`
  font-family: ${INTER.regular};
  font-size: 12px;
  font-weight: 400;
  color: ${GRAYSCALE_500};
`

export const Price = styled.span`
  font-family: ${GIVONIC.black};
  font-size: 15px;
  font-weight: 900;
  background: linear-gradient(180deg, #3C53D7 0%, #1A1B6E 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`
